import {useStore} from "vuex";
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";

export default function UseCrudHouse() {

  const store = useStore(),
    route = useRoute(),
    router = useRouter()

  store.commit('housesList/setCurrentPage', Number(route.query['page']) || 1)

  store.dispatch('housesList/searchHouses', route.query['search'])

  const changePage = newNumber => {
    let page = Number(newNumber)
    if (page === 1) {
      page = undefined
    }
    router.push({name: 'Home', query: {...route.query, page: page}})
    store.commit('housesList/setCurrentPage', Number(newNumber))
    store.dispatch('housesList/reloadOrResearchHouses')
  }

  const reloadDataByRouteQuery = () => {
    store.commit('housesList/setSearchInput', route.query['search'])
    changePage(route.query['page'] || 1)
  }

  const deleteHouse = link => store.dispatch('house/deleteHouse', link)
    .then(response => {
      if (store.getters["housesList/getHousesList"].list.length === 1) {
        if (store.getters["housesList/getHousesList"].paginator.pages.length > 2) {
          changePage(store.state.housesList.currentPage - 1)
        } else {
          changePage(1)
        }
      } else {
        store.dispatch('housesList/reloadOrResearchHouses')
      }
      return response
    })

  const countHousesOnPage = computed({
    get: () => store.state.countHousesOnPage.countHousesOnPage,
    set: newVal => {
      store.commit('countHousesOnPage/setCountHousesOnPage', newVal)
      changePage(1)
    }
  })

  const countHousesOnPageValues = computed(
    () => store.state.housesList.countHousesOnPageValues.map(i => ({name: `Показывать по ${i}`, value: i}))
  )

  return {
    housesList: computed(() => store.getters["housesList/getHousesList"].list),
    paginator: computed(() => store.getters["housesList/getHousesList"].paginator),
    listLoadingStatus: computed(() => store.state.housesList.listLoadingStatus),
    isDeleteHouseLoading: computed(() => store.state.house.isDeleteHouseLoading),
    coordinatesList: computed(() => store.getters['housesList/coordinatesList']),
    currentPage: computed(() => store.state.housesList.currentPage),
    countHousesOnPageValues,
    changePage,
    deleteHouse,
    countHousesOnPage,
    reloadDataByRouteQuery
  }
}
